import Details from "../components/projectUserDetails";
import { UpdateNavigations } from "../store/actions";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import useCustomState from "../hooks/State";

const ProjectUserDetails = (props) => {
  const isLoading = useCustomState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    let navigations;
    const projectId = props.match.params.pId;
    const userId = props.match.params.userId;
    navigations = [
      { name: "مدیریت پروژه ها", path: "/admin/projects" },
      { name: "جزئیات پروژه", path: "/admin/project-dash/" + projectId },
      {
        name: "کنتورهای کاربر",
        path: "/admin/project-dash/" + projectId + "/users/" + userId,
      },
    ];
    dispatch(UpdateNavigations(navigations));
    isLoading.handleChange(false);
  }, []);

  const data = {
    history: props.history,
    location: props.location,
    match: props.match,
  };
  return (
    <>
      <Details data={data} />
    </>
  );
};

export default ProjectUserDetails;
